<template>
    <div id="app">
        <jokes-component />
    </div>
</template>

<script>
import JokesComponent from "./components/JokesComponent.vue";

export default {
    components: {
        JokesComponent
    }
};
</script>
